import React from 'react'
import DietCaresec1 from './DietCaresec1/DietCaresec1'
import DietCaresec2 from './DietCaresec2/DietCaresec2'
import DietCaresec3 from './DietCaresec3/DietCaresec3'

function DietCare() {
  return (
    <>
      <DietCaresec1 />
      <DietCaresec2 />
      <DietCaresec3 />
    </>
  )
}

export default DietCare
